import { gql } from 'graphql-tag'

export const WHOLESALE = gql`
  query wholesale(
    $where: ElementWhereInput
    $first: Int
    $order: ElementOrderByInput
  ) {
    elements(where: $where, first: $first, order: $order) {
      nodes {
        id
        code
        name
        detailText
        detailPicture {
          id
          url
        }
      }
    }
  }
`
